import { render } from "./shedMonitorNew.vue?vue&type=template&id=ba24dbb6&scoped=true"
import script from "./shedMonitorNew.vue?vue&type=script&lang=js"
export * from "./shedMonitorNew.vue?vue&type=script&lang=js"

import "./shedMonitorNew.vue?vue&type=style&index=0&id=ba24dbb6&lang=scss"
import "./shedMonitorNew.vue?vue&type=style&index=1&id=ba24dbb6&lang=scss&scoped=scoped"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba24dbb6"]])

export default __exports__